module.exports = __webpack_public_path__ + "img/dierbu.61fa4700.png";